export default __webpack_public_path__ + "assets/7b45cc7e0f3a75c9597ac2f7ba37469a.png";